import { render } from "./BalForm.vue?vue&type=template&id=e5207e18&ts=true"
import script from "./BalForm.vue?vue&type=script&lang=ts"
export * from "./BalForm.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__